import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AccessibilityProvider } from "./contexts/AccessibilityContext";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";

// Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import DigitalMarketing from "./pages/services/DigitalMarketing";
import ITConsulting from "./pages/services/ITConsulting";
import SoftwareDevelopment from "./pages/services/SoftwareDevelopment";
import AISolutions from "./pages/services/AISolutions";
import CloudDevOps from "./pages/services/CloudDevOps";
import ERP from "./pages/services/ERP";
import GovEnterprise from "./pages/services/GovEnterprise";

import Training from "./pages/Training";
import GovEducation from "./pages/GovEducation";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";


/**
 * Scroll to top on ROUTE change
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

/**
 * Back to Top button (appears on scroll)
 */
function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() =>
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
      aria-label="Back to top"
      title="Back to top"
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 1000,
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        border: "none",
        backgroundColor: "#0d3b66",
        color: "#ffffff",
        fontSize: "20px",
        cursor: "pointer",
        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
      }}
    >
      ↑
    </button>
  );
}

/**
 * Layout component
 */
function Layout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AccessibilityProvider>
        <LanguageProvider>
          <ScrollToTop />
          <BackToTop />

          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/training" element={<Training />} />
              <Route
                path="/government-education"
                element={<GovEducation />}
              />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
              <Route path="/services/it-consulting" element={<ITConsulting />} />
              <Route path="/services/software-development" element={<SoftwareDevelopment />} />
              <Route path="/services/ai" element={<AISolutions />} />
              <Route path="/services/cloud-devops" element={<CloudDevOps />} />
              <Route path="/services/erp" element={<ERP />} />
              <Route path="/services/gov-enterprise" element={<GovEnterprise />} />
            </Routes>
          </Layout>
        </LanguageProvider>
      </AccessibilityProvider>
    </BrowserRouter>
  );
}

export default App;
